const MODAL_WINDOW = 'remote-video-modal';

function initVideoModal() {
  jQuery(window).on('load', () => {
    showVideoModal();
  });
}

function showVideoModal() {
  const videoLink = jQuery('.video-link');

  if (videoLink.length) {
    renderModalWindow();

    videoLink.each((key, el) => {
      const link = jQuery(el);

      if (link.hasClass('open-modal')) {
        link.addClass('external-link-popup-disabled');
        link.attr('data-bs-toggle', 'modal');
        link.attr('data-bs-target', '#' + MODAL_WINDOW);
        const modalIframe = jQuery('.video-modal iframe');

        link.on('click', (e) => {
          e.preventDefault();
          const href = link.attr('href');
          const playerLink = getVideoLink(href);

          if (playerLink.length) {
            jQuery(window).on('shown.bs.modal', function () {
              modalIframe.attr('src', playerLink + '?badge=0&autoplay=0');
              jQuery('html').addClass('body--video-modal-visible');
              closeVideoModal();
            });

            jQuery(window).on('hide.bs.modal', function () {
              modalIframe.removeAttr('src');
              jQuery('html').removeClass('body--video-modal-visible');
            });
          }
        });
      }
    });
  }
}

function closeVideoModal() {
  const modalDialog = jQuery('#' + MODAL_WINDOW);
  const videoBlock = jQuery('.modal-dialog');

  modalDialog.on('click', (e) => {
    if (videoBlock.is(e.target)) {
      modalDialog.modal('hide');
    }
  });
}

function getVideoLink(href) {
  let link = null;
  if (href.indexOf('vimeo') > -1) {
    const regExpShort = /vimeo\.com\/([0-9]*)/i;
    const regExpPalyer = /vimeo\.com\/video\/(\d+)/i;
    let id;

    if (href.match(regExpShort)[1].length) {
      id = href.match(regExpShort)[1];
    } else if (href.match(regExpPalyer)[1]) {
      id = href.match(regExpPalyer)[1];
    }

    link = 'https://player.vimeo.com/video/' + id;
  }

  return link;
}

function renderModalWindow() {
  const modal = `
    <div id="${MODAL_WINDOW}" class="video-modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button class="video-modal__close close-btn" type="button" data-dismiss="modal" aria-label="Close">
            <i class="ico-close"></i>
          </button>
          <div class="modal-body">
            <div class="ratio ratio-16x9">
              <iframe class="embed-responsive-item" src="" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>`;

  if (jQuery('.app-main').length) {
    jQuery('.app-main').append(modal);
  }
}

export { initVideoModal };
